import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import store from './redux/config/confingStore'
import { Provider } from 'react-redux'
import { QueryClientProvider, QueryClient } from 'react-query'
import ScrollToTop from './components/ScrollReset'

const queryClient = new QueryClient()
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <BrowserRouter>
        <ScrollToTop />
        <App />
      </BrowserRouter>
    </Provider>
  </QueryClientProvider>,
)
